export const link: Style = () => ({
  display: 'flex',
  justifyContent: 'center',
})
